/**
*  @class
*  @function FacetsToggle
*/
class FacetsToggle {
  constructor() {
    this.container = document.getElementById("Facet-Drawer");
    let button = document.getElementById("Facets-Toggle");

    // Add functionality to buttons
    if (button) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle("open-cc");
        if (this && this.container) {
          this.container.classList.toggle("active");
        }
      });
    }
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    if (this.querySelector("form")) {
      this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
    }
  }

  connectedCallback() {
    const element = this;
    const mobileBreakpoint = 1068;
    const stickyHeader = document.querySelector(".header--sticky");
    let lastScrollY = window.scrollY;
    const overlayElement = element.querySelector(".ss__slideout__overlay");

    setInterval(() => {
      const thisFormOriginalSort = element.querySelector("form > .thb-filter-sort-count");
      const copiedFormOriginalSort = element.querySelector("form > div.flex");

      if (!thisFormOriginalSort || !copiedFormOriginalSort) {
        return;
      }

      const getAllOriginalSortingItem = thisFormOriginalSort.querySelectorAll(".ss__dropdown__content .ss__list .ss__list__option a");
      const getAllCopiedSortingItem = copiedFormOriginalSort.querySelectorAll(".ss__dropdown__content .ss__list .ss__list__option a");

      if (getAllOriginalSortingItem && getAllOriginalSortingItem.length > 0) {
        getAllOriginalSortingItem.forEach((originalItem, index) => {
          const originalHref = originalItem.getAttribute("href");
          const copiedItem = getAllCopiedSortingItem[index];
          if (copiedItem && copiedItem.getAttribute("href") !== originalHref) {
            copiedItem.setAttribute("href", originalHref);
          }
        });
      }
    }, 1000);

    const toggleStickyHeader = (isDrawerActive) => {
      const clickCaptureElement = document.querySelector(".click-capture");
      const clickCaptureProductElement = document.querySelector(".click-capture--product");

      if (stickyHeader) {
        if (isDrawerActive) {
          stickyHeader.classList.replace("fixed", "relative");
          if (window.innerWidth <= mobileBreakpoint) {
            stickyHeader.classList.add("hidden");
          }
          clickCaptureElement?.classList.add("disable-blur-on-click");
          clickCaptureProductElement?.classList.add("disable-blur-on-click");
        } else {
          stickyHeader.classList.replace("relative", "fixed");
          stickyHeader.classList.add("w-full");
          stickyHeader.classList.remove("hidden");
          clickCaptureElement?.classList.remove("disable-blur-on-click");
          clickCaptureProductElement?.classList.remove("disable-blur-on-click");
        }
      }
    };

    if (overlayElement) {
      overlayElement.addEventListener("click", () => {
        if (stickyHeader && stickyHeader.classList.contains("hidden")) {
          stickyHeader.classList.remove("hidden");
        }
      });
    }

    element.addEventListener("click", function (e) {
      if (e.target.id === "Facets-Toggle") {
        const isDrawerActive = this.querySelector(".ss__slideout--active");
        toggleStickyHeader(isDrawerActive);
      }
    });

    if (window.innerWidth <= mobileBreakpoint && stickyHeader) {
      const facetRemove = element.querySelector("facet-remove");
      const productGrid = document.querySelector("#product-grid");
      const filterMobileProductCount = element.querySelector(".thb-filter-sort-count");
      window.addEventListener("scroll", function () {
        const headerHeight = stickyHeader.offsetHeight;
        const borderTriggerPoint = headerHeight;
        const currentScrollY = window.scrollY;
        let currentDistanceFromTop = null;
        if (productGrid) {
          currentDistanceFromTop = productGrid.getBoundingClientRect().top;
        }

        element.classList.add("sticky", "bg-white");

        if (stickyHeader.classList.contains("translate-y-0")) {
          element.style.top = `${headerHeight}px`;
          element.style.borderBottom = "2px solid black";
        } else {
          element.style.top = "0px";
        }

        if (facetRemove) {
          if (currentDistanceFromTop <= 250 && element.style.top > 0) {
            facetRemove.style.display = "none";
          } else if (currentDistanceFromTop <= 250 && element.style.top === 0) {
            facetRemove.style.display = "none";
          } else if (currentDistanceFromTop > 250 && element.style.top !== 0) {
            facetRemove.style.display = "block";
          } else {
            facetRemove.style.display = "none";
          }
        }

        if (filterMobileProductCount) {
          if (currentDistanceFromTop <= 250 && element.style.top > 0) {
            filterMobileProductCount.style.display = "none";
          } else if (currentDistanceFromTop <= 250 && element.style.top === 0) {
            filterMobileProductCount.style.display = "none";
          } else if (currentDistanceFromTop > 250 && element.style.top !== 0) {
            filterMobileProductCount.style.display = "block";
          } else {
            filterMobileProductCount.style.display = "none";
          }
        }

        if (currentScrollY > borderTriggerPoint) {
          if (
            !(stickyHeader.classList.contains("min-[1068px]:fixed") || stickyHeader.classList.contains("relative")) &&
            stickyHeader.classList.contains("fixed") &&
            currentScrollY > 500
          ) {
            element.style.top = `${headerHeight}px`;
            element.style.borderBottom = "2px solid black";
          }
          if (currentScrollY > lastScrollY && currentScrollY > 500) {
            element.style.borderBottom = "2px solid black";
          } else if (
            !(stickyHeader.classList.contains("min-[1068px]:fixed") || stickyHeader.classList.contains("relative")) &&
            stickyHeader.classList.contains("fixed") &&
            currentScrollY > 500
          ) {
            element.style.borderBottom = "2px solid black";
          } else {
            if (stickyHeader.classList.contains("translate-y-0")) {
              element.style.borderBottom = "2px solid black";
            } else if (stickyHeader.classList.contains("-translate-y-full")) {
              element.style.borderBottom = "2px solid black";
            } else {
              element.style.borderBottom = "none";
            }
          }
        } else {
          element.style.top = "0px";
          element.style.borderBottom = "none";
        }
        lastScrollY = currentScrollY;
      }, { passive: true });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName("thb-filter-count");
    document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading");

    for (var item of container) {
      item.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          {
            html,
            url,
          },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount");
    const container = document.getElementsByClassName("thb-filter-count");

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove("loading");
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll("#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row");
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest("collapsible-row") : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest("collapsible-row"));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-filter-count"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML = source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      {
        searchParams,
      },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const currentHash = window.location.hash.slice(2);
    const hashParts = currentHash.split("/");

    const filterParams = hashParts.filter((part) => part.includes("filter:")).join("/");
    const sortParam = hashParts.find((part) => part.includes("sort:")) || "";

    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData);

    if (searchParams.get("filter.v.price.gte") === "0.00") {
      searchParams.delete("filter.v.price.gte");
    }
    if (document.querySelector(".price_slider")) {
      if (searchParams.get("filter.v.price.lte") === parseFloat(document.querySelector(".price_slider").dataset.max).toFixed(2)) {
        searchParams.delete("filter.v.price.lte");
      }
    }

    const newFilterParams = [];
    searchParams.forEach((value, key) => {
      if (key.includes("filter:")) {
        newFilterParams.push(`${key}:${value}`);
      }
    });

    const combinedFilters = [...new Set([...filterParams.split("/"), ...newFilterParams])].join("/");
    const newSortParam = searchParams.get("sort") ? `sort:ss_price:${searchParams.get("sort")}` : sortParam;
    const combinedParams = `${combinedFilters ? combinedFilters + "/" : ""}${newSortParam || ""}`;

    FacetFiltersForm.renderPage(combinedParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("a").forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define("facet-remove", FacetRemove);

/**
*  @class
*  @function PriceSlider
*/
class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector(".price_slider"),
      amounts = this.querySelector(".price_slider_amount"),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        range: {
          min: 0,
          max: parseFloat(slider.dataset.max),
        },
      },
      event = new CustomEvent("input"),
      form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on("update", function (values) {
      amounts.querySelector(".field__input_min").value = values[0];
      amounts.querySelector(".field__input_max").value = values[1];
    });
    slider.noUiSlider.on("change", function (values) {
      form.querySelector("form").dispatchEvent(event);
    });
  }
}
customElements.define("price-slider", PriceSlider);

window.addEventListener("load", () => {
  new FacetsToggle();
});
